import React, { FC, useState } from 'react';
import { Collapse, Tag, Tooltip } from '@duxton-web/ui';

import { ROLES_MAPPING } from '../parseRoleToRoleObject';
import { getShowPublisherFlag } from '../utils';
// eslint-disable-next-line import/no-named-as-default
import RolesDescriptionsMap from './RolesDescriptionsMap';

import './UserRolesLegend.css';

interface UserRolesLegendProps {}

const UserRolesLegend: FC<UserRolesLegendProps> = () => {
  const [collapsed, setCollapsed] = useState<boolean>(false);

  function getRolesDescriptions() {
    let blacklist = ['Publisher'];
    const showPublisherFlag = getShowPublisherFlag();
    if (showPublisherFlag) {
      blacklist = ['RolloutModerator', 'ExperimentModerator'];
    }
    return ROLES_MAPPING.filter((r) => !blacklist.includes(r.role)).map(
      ({ role, color }) => (
        <li key={role}>
          <Tooltip title={RolesDescriptionsMap[role]}>
            <Tag size="xsmall" color={color}>
              {role}
            </Tag>
          </Tooltip>
          &nbsp;{RolesDescriptionsMap[role]}
        </li>
      ),
    );
  }

  return (
    <section className="user-roles-legend">
      <Collapse
        activeKey={collapsed ? [] : ['user-roles']}
        onChange={() => setCollapsed(!collapsed)}
      >
        <Collapse.Panel header="Roles legend" key="user-roles">
          <h3>Users in grab-x may have following roles:</h3>
          <ul>{getRolesDescriptions()}</ul>
        </Collapse.Panel>
      </Collapse>
    </section>
  );
};

export default UserRolesLegend;
